export default {
  tags () {
    this.innerTags = [...this.tags]
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/companies/components/tags/resources/watch.js